import { useState } from 'react';
import MediaGallery from '../../../../components/MediaGallery/MediaGallery';
import steps from './img/steps.png';
import usps from './img/usps.png';
import guarantee from './img/guarantee.png';
import './Default.sass';
import { getPriceWithCurrency, getSavingsPercent } from '../../../../utils/helpers';
import ProductSelector from '../../ProductSelector/ProductSelector';

export default function Default({ specialOffer, onSubmit, offer }) {
  const mergedProductsData = specialOffer.productsData.map((product) => {
    const productDetail = specialOffer.productDetails[product.id];

    return {
      ...product,
      ...productDetail,
    };
  });

  const [selectedProduct, setSelectedProduct] = useState(mergedProductsData[0]);
  const discount = getSavingsPercent(selectedProduct.oldPrice, selectedProduct.price);

  function handleProductSelect(product) {
    setSelectedProduct(product);
  }

  return (
    <>
      <header className='page-header'>
        <div className='container'>
          <div className='page-header-inner'>
            <div className='page-header__hurry'>
              <b>HURRY!</b> Only 42 left in stock!
            </div>
            <div className='page-header__steps'>
              <img src={steps} alt='steps' />
            </div>
          </div>
        </div>
      </header>

      <main className='page-main'>
        <section className='greetings'>
          <div className='container'>
            <div className='greetings-inner'>
              <h3>WAIT! You Have Qualified for a SPECIAL OFFER!</h3>
              <h1>{specialOffer.headline}</h1>
              <h2>
                Add this to your order and <b>get a {discount}% discount</b>
              </h2>
            </div>
          </div>
        </section>

        <section className='product-info'>
          <div className='container'>
            <div className='product-info-inner'>
              {/* left */}
              <div className='product-info-left'>
                <div className='product-info__header'>
                  <h3>{specialOffer.productName}</h3>
                  <div className='product-info__stars'>
                    <i className='fas fa-star'></i>
                    <i className='fas fa-star'></i>
                    <i className='fas fa-star'></i>
                    <i className='fas fa-star'></i>
                    <i className='fas fa-star'></i>
                    {specialOffer.delivered || '18,500'} delivered
                  </div>
                </div>

                <ul className='product-info__benefits'>
                  {specialOffer.benefits.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                {mergedProductsData.length > 1 ? (
                  <ProductSelector
                    offer={offer}
                    specialOffer={specialOffer}
                    products={mergedProductsData}
                    selectedProduct={selectedProduct}
                    onSelect={handleProductSelect}
                  />
                ) : (
                  <div className='product-info-prices'>
                    <div className='product-info-prices__msrp'>
                      <p>Regular Price</p>
                      <b>{getPriceWithCurrency(selectedProduct.oldPrice, offer?.locale, offer?.currency)}</b>
                      <s>+ {getPriceWithCurrency(8.95, offer?.locale, offer?.currency)} SHIPPING</s>
                    </div>
                    <div className='product-info-prices__offer'>
                      <p>
                        Your Price <span>({discount}% off)</span>
                      </p>
                      <b>{getPriceWithCurrency(selectedProduct.price, offer?.locale, offer?.currency)}</b>
                      <span>+ FREE SHIPPING</span>
                    </div>
                  </div>
                )}

                <div
                  className='product-info-cta js-yes-button animate__animated animate__pulse animate__infinite'
                  onClick={() => onSubmit(selectedProduct)}
                >
                  Yes! Add To My Order!
                </div>

                <div className='ships-info'>
                  {specialOffer.shippingText ? (
                    <p dangerouslySetInnerHTML={{ __html: specialOffer.shippingText }}></p>
                  ) : (
                    <>
                      <img src={usps} alt='usps' />
                      <p>
                        All orders ship from the USA 🇺🇸 via USPS within 1 business day. A tracking number will
                        be issued to your email.
                      </p>
                    </>
                  )}
                </div>

                <div className='product-right-guarantee product-right-guarantee--mob'>
                  <p>Guaranteed Safe Checkout</p>
                  <img src={guarantee} alt='guarantee' />
                </div>
              </div>
              {/* end left */}

              {/* right */}
              <div className='product-info-right'>
                <MediaGallery items={specialOffer.gallery} />

                <div className='product-right-guarantee product-right-guarantee--desk'>
                  <p>Guaranteed Safe Checkout</p>
                  <img src={guarantee} alt='guarantee' />
                </div>
              </div>
              {/* end right */}
            </div>
          </div>
        </section>

        <section className='no-button-wrapper'>
          <button onClick={() => onSubmit()} className='no-button'>
            No, I Don’t Want This Deal
          </button>
        </section>

        <i className='far fa-chevron-double-down animate__animated animate__fadeInDown animate__infinite animate__slow'></i>
      </main>
    </>
  );
}
